<form class="gap-lg grid" [formGroup]="form">
  <div hlmFieldGroup>
    <fieldset hlmFieldSet>
      <div hlmFieldGroup>
        <div hlmField>
          <label hlmFieldLabel for="input-nom" labelRequired>Nom de la formation</label>
          <input id="input-nom" hlmInput type="text" formControlName="nom" />
        </div>
        <div hlmField>
          <label hlmFieldLabel for="textarea-code" labelRequired>Code de la formation</label>
          <textarea id="textarea-code" hlmTextarea formControlName="code"></textarea>
        </div>
        <div hlmField>
          <label hlmFieldLabel for="input-validite">Durée de validité de la formation</label>
          <input id="input-validite" hlmInput type="number" inputmode="numeric" formControlName="validite" />
          <p hlmFieldDescription>Durée exprimée en années</p>
        </div>
        <div hlmField>
          <label hlmFieldLabel for="textarea-description">Description</label>
          <textarea id="textarea-description" hlmTextarea formControlName="description"></textarea>
        </div>
        <div hlmField>
          <label hlmFieldLabel for="textarea-public">Public concerné</label>
          <textarea id="textarea-public" hlmTextarea formControlName="public"></textarea>
        </div>
        <div hlmField>
          <label hlmFieldLabel for="textarea-prerequis">Prérequis</label>
          <textarea id="textarea-prerequis" hlmTextarea formControlName="prerequis"></textarea>
        </div>
      </div>
    </fieldset>
    <hlm-field-separator />
    <fieldset hlmFieldSet formArrayName="niveaux">
      <legend hlmFieldLegend>Niveaux</legend>
      <p hlmFieldDescription>Définissez les différents niveaux de la formation.</p>
      @for (_ of niveaux.controls; track $index; let idx = $index; let first = $first) {
        <app-expansion-panel
          [titre]="'Niveau ' + (idx + 1)"
          [id]="'niveau-' + idx"
          [isOpen]="first"
          [item]="idx"
          [actions]="niveauActions"
        >
          <div class="gap-lg p-lg grid" [formGroupName]="idx" hlmFieldGroup>
            <div hlmField>
              <label [for]="'input-nom-' + idx" hlmFieldLabel>Nom du niveau</label>
              <input [id]="'input-nom-' + idx" hlmInput type="text" formControlName="nom" />
            </div>
            <div hlmField>
              <label [for]="'input-duree-' + idx" hlmFieldLabel>Durée du niveau</label>
              <input [id]="'input-duree-' + idx" hlmInput type="number" formControlName="duree" />
              <p hlmFieldDescription>Durée exprimée en heures</p>
            </div>
          </div>
        </app-expansion-panel>
      }
      <app-button-add-new (click)="ajouterNiveau()" label="Ajouter un niveau" />
    </fieldset>
  </div>
</form>
